let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bNYii")).then(() => parcelRequire('5klOl'));